<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7raqr0/tc-custom/9781504084826.jpg?1728851674299" alt="This image is the cover for the book Under the Shadows, The Lola Wicks Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Under the Shadows, The Lola Wicks Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A “flawed, complex, compelling heroine faces challenges that are both gut-wrenchingly difficult and all too common today . . . Far above the crowd.” —<i>Kirkus Reviews</i></b><br/>  <br/> Ravaged by loss and suffering under the weight of addiction, journalist Lola Wicks’s life takes a bad turn after a family tragedy. The only reason she agrees to travel to Salt Lake City to write a human interest story on overseas adoptions is to prove that she is still managing her life—and show the authorities she’s still a fit mother. But the assignment is immediately complicated when her subject, a Vietnamese teen adopted by a white family, is accused of murder. Determined to prove his innocence, Lola investigation takes her to the edges of the darkness pervading her own life—making her wonder if she’ll ever find her way back again.<br/>  <br/> “Engrossing . . . Few will be able to resist this moving tale of redemption.” —<i>Publishers Weekly</i><br/>  <br/><b>Praise for the Lola Wicks mysteries</b><br/><br/> “A gutsy series.” —<i>The New York Times</i><br/>  <br/> “Gwen Florio weaves a compelling tapestry that combines family saga, social consciousness and human frailty.” —Craig Johnson, <i>New York Times–</i>bestselling author on <i>Disgraced</i><br/>  <br/> “The writing is top-notch, and the action builds at just the right pace . . . [Amateur sleuth] Lola Wicks is going to be around for a long, long time.” —<i>Kirkus Reviews</i> on <i>Dakota</i><br/>  <br/> “Compelling, realistically flawed characters and a timely story line . . . make this one of Florio’s hardest-hitting mysteries yet.” —<i>Library Journal</i>, starred review on <i>Reservations</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gwen Florio
      </h2>
      
      <p class="authorDescription body article">Gwen Florio, a former editor at the&#160;<I>Missoulian</I>, is an award-winning journalist and an adjunct professor in University of Montana&rsquo;s School of Journalism. Florio is the author of the Lola Wicks crime series as well as<I>&#160;Silent Hearts</I>, a novel set in Afghanistan. Her first novel,&#160;<I>Montana</I>, won the Pinckley Prize for Debut Novel, and a High Plains Book Award.&#160;<I>Best Laid Plans</I>,&#160;the first book in her new crime series, the Nora Best Mysteries, published in 2020. She currently lives in Montana with her partner and dog.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bf7e4b4